export { FavoriteIcon } from './FavoriteIcon/FavoriteIcon';
export { PopularityIcon } from './PopularityIcon/PopularityIcon';
export { RatingIcon } from './RatingIcon/RatingIcon';
export { ToWatchIcon } from './ToWatchIcon/ToWatchIcon';
